ALKMaps.Control.CustomPlaceDragFeature = ALKMaps.Class(ALKMaps.Control.DragFeature, {
  initialize: function (layer, options) {
    ALKMaps.Control.DragFeature.prototype.initialize.apply(this, arguments);
  },

  onStart: function (feature, pixel) {
    var llPix = feature.layer.map.getViewPortPxFromLonLat(feature.lonlat);
    var deltaX = llPix.x - pixel.x;
    var deltaY = llPix.y - pixel.y;
    feature.deltaXY = {x:deltaX, y: deltaY};
  },

  onDrag: function (feature, pixel) {
    if (feature.popup) {
      feature.popup.div.style.display = 'none';
    }    
  },

  CLASS_NAME: "ALKMaps.Control.CustomPlaceDragFeature"
});



// WEBPACK FOOTER //
// ./app/alkmapsExtension/controlCustomPlaceDragFeature.js